<template>
  <div class="modal fade" id="generalDocumentsUploadModal" tabindex="-1" role="dialog" aria-labelledby="generalDocumentsUploadModalLabel" aria-hidden="true">
    <div class="modal-dialog" :class="isForFolder ? 'modal-xl' : ''" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="generalDocumentsUploadModalLabel">Pictures</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <document-gallary :documents="documents"
            @deleteImage="deleteImage"
            @moveOutOfFolder="moveOutOfFolder"
          />
          <div class="form-group">
            <label class="custom-label">Upload Images</label>
            <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions"
              @vdropzone-success="fileUploaded"
            />
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-warning" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import VueDropzone from 'vue2-dropzone'
  import 'vue2-dropzone/dist/vue2Dropzone.min.css'

  export default {
    props: {
      url: null,
      documents: null,
      isForFolder: {
        default: false,
      },
    },
    components: { VueDropzone },
    data() {
      return {
        dropzoneOptions: {
          url: this.url,
          headers: {
            'X-CSRF-TOKEN': window.token,
          },
        }
      }
    },
    methods: {
      fileUploaded(file, generalDoc) {
        this.$emit('fileUploaded', generalDoc)
      },
      deleteImage(doc) {
        if (confirm('Do you really want to delete this image?')) {
          window.axios.delete(`/documents/${doc}`).then(({data}) => {
            window.notification.success(`Image has been deleted`, 'Success!')
            const index = this.documents.findIndex(eDoc => eDoc.id === doc)
            this.documents.splice(index, 1)
          })
        }
      },
      moveOutOfFolder(doc) {
        const index = this.documents.findIndex(eDoc => eDoc.id === doc.id)
        this.documents.splice(index, 1)
        this.$store.commit('addGeneralDocument', doc)
      },
    },
    mounted() {
      $('#generalDocumentsUploadModal').on('show.bs.modal', () => {
        this.$refs.myVueDropzone.setOption('url', this.url)
        this.$refs.myVueDropzone.removeAllFiles()
      })
    },
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// resources/js/components/GeneralDocumentsUploadModal.vue